import InService from "./InService";

export default InService;
